import React from 'react';
import Signup from './Signup';
import * as Animate from "react-reveal"

export default function Newsletter() {
  return (
    <section className="newsletter-bg bg-cover bg-center bg-clip mb-12 lg:mb-16" >
      <div className='w-11/12 mx-auto py-16 lg:py-24 max-w-7xl'>
        <div className='w-full flex flex-col justify-center items-center py-6 md:pt-14 md:pb-14 lg:pt-14 lg:pb-20 max-w-full md:max-w-[700px] mx-auto'>
          <Animate.Fade bottom>
            <div className='flex flex-col justify-content items-center mb-8 '>
              <h1 className='text-white text-center font-semibold mb-4 lg:mb-6  md:text-left text-2xl  md:text-3xl lg:text-4xl xl:text-5xl'>Sign up for our newsletter</h1>
              <p className='text-white text-center text-base md:text-lg'>Be the first to know about our releases, industry news and insights.</p>
            </div>

            <div className='w-full mt-4 lg:mt-6'>
              <Signup />
            </div>

          </Animate.Fade>
        </div>
      </div>
    </section>
  );
}
